import { useMemo } from 'react';
import { DataTable } from 'components/data-table';
import { cleanupFiltersAtom, EMPTY_FILTERS } from './atoms';
import { useCleanupLog } from './hooks';
import { CLEANUP_COLUMNS } from './cleanup-columns';
import { CleanupFilters } from './cleanup-filters';
import { CleanupStats } from './cleanup-stats';
import { CleanupDetail } from './cleanup-detail';
import { useLogFilters } from '../hooks';

/**
 * The clean-up log: summary stats, filters, and the server-paged table of merge
 * actions, each row expanding to its full detail.
 * @return {JSX.Element} The log
 */
export function CleanupLogTable() {
  const { filters, onPaginationChange } = useLogFilters(
    cleanupFiltersAtom,
    EMPTY_FILTERS
  );
  const { data, isFetching, isPending, isError } = useCleanupLog(filters);
  const rows = useMemo(() => data?.results ?? [], [data]);

  return (
    <div>
      <CleanupStats stats={data?.stats} loading={isPending} />
      <CleanupFilters />

      <DataTable
        data={rows}
        columns={CLEANUP_COLUMNS}
        getRowId={(row) => row.rowKey}
        isLoading={isFetching}
        error={
          isError
            ? "Couldn't load the clean-up log. Refresh to try again."
            : null
        }
        persistenceKey="entity-cleanup-log"
        // The filters atom owns the page, so the footer follows a filter
        // change or Reset back to page 1.
        controlledState={{
          pagination: { page: filters.page, pageSize: filters.perPage },
        }}
        scroll={{
          mode: 'paginated',
          serverDriven: true,
          totalCount: data?.totalCount ?? 0,
        }}
        onPaginationChange={onPaginationChange}
        renderRowSubComponent={(row) => <CleanupDetail row={row.original} />}
        config={{
          columnResizing: true,
          columnReordering: false,
          columnPinning: true,
          sorting: false,
          columnVisibility: true,
          globalSearch: false,
          columnFilters: false,
        }}
      />
    </div>
  );
}
